import { IIconProps } from '@fluentui/react';
import { AppState } from '../../../redux/reducers';
import { ErrorType } from '../../../models/HttpError';

// models
import { Contract } from '../../../models/Entities/Contracts/Contract';
import { ContractCommissionAgent } from '../../../models/Entities/Contracts/ContractCommissionAgent';
import { Protocol } from '../../../models/Entities/Protocols/Protocol';
import { ProtocolPractitioner } from '../../../models/Entities/Protocols/ProtocolPractitioner';

// stores
import * as ContractCommissionAgentStore from '../../../redux/middleware/ContractCommissionAgentMiddleware';

/* Nota de vocabulario: la pantalla dice "colaboradores" y el código dice
   "commissionAgent". No es una inconsistencia que haya que emparejar. La API
   nombra así a la entidad y el código la sigue, porque es contra esa API que se
   programa; la pantalla usa la palabra que el usuario usa, y además "comisionista"
   describía sólo el cobro cuando lo que se da de alta acá es una relación
   administrativa más amplia. */

//#region Icons
export const AddIcon: IIconProps = { iconName: 'AddFriend' };
export const EditIcon: IIconProps = { iconName: 'Edit' };
//#endregion Icons

export interface IProps {
  ContractId: number;
  /**
   * Protocolo del contrato, para saber a quién ya muestra la grilla de arriba.
   * Puede faltar: un contrato sin protocolo no tiene equipo médico, y entonces
   * todos sus comisionistas son "otros".
   */
  ProtocolId?: number | undefined;
}

interface ConnectedProps {
  isLoading: boolean;
  error: ErrorType | undefined;
  Agents: ContractCommissionAgent[];
}

interface DispatchProps {
  GetAllContractCommissionAgents: typeof ContractCommissionAgentStore.actionCreators.GetAllContractCommissionAgents;
}

export type Props = IProps & ConnectedProps & DispatchProps;

/**
 * Los comisionistas que esta sección tiene que mostrar: los que la grilla de
 * profesionales del protocolo NO está mostrando ya.
 *
 * El criterio es "no está arriba" y no "no es de tipo profesional", a propósito.
 * Filtrar por tipo dejaría fuera de la pantalla a un comisionista cargado como
 * profesional que no participa de este protocolo: existiría, cobraría, y no se
 * vería en ningún lado. Preguntando por la lista de arriba, todo lo que hay en el
 * contrato aparece en un lugar o en el otro, nunca en ninguno.
 */
export const GetAgentsOutsideProtocolTeam = (
  agents: ContractCommissionAgent[] | undefined,
  protocolPractitionerIds: string[]
): ContractCommissionAgent[] =>
  (agents ?? []).filter(
    (agent: ContractCommissionAgent) => !protocolPractitionerIds.includes(agent.commissionAgentId)
  );

export const mapStateToProps = (state: AppState, ownProps: IProps) => {
  const contract: Contract | undefined = state.Contract?.list?.find(
    (item: Contract) => item.id === ownProps.ContractId
  );

  const protocol: Protocol | undefined = ownProps.ProtocolId
    ? state.MedicalProtocols?.list?.find((item: Protocol) => item.id === ownProps.ProtocolId)
    : undefined;

  const protocolPractitionerIds: string[] =
    protocol?.practitioners?.map(
      (practitioner: ProtocolPractitioner) => practitioner.practitionerUserId
    ) ?? [];

  return {
    isLoading: state.ContractCommissionAgent?.isLoadingAll,
    error: state.ContractCommissionAgent?.error,
    Agents: GetAgentsOutsideProtocolTeam(contract?.commissionAgents, protocolPractitionerIds),
    ...ownProps
  };
};

export const mapDispatchToProps = {
  ...ContractCommissionAgentStore.actionCreators
};
